<i18n>
    {
        "ru": {
            "gender-male": "Мужской",
            "at": "в",
            "gender-female": "Женский",
            "gender-unisex": "Унисекс",
            "news_is_liked": "Новость добавлена в избранное",
            "news_liked_already": "Новость уже добавлена в избранное",
            "news_is_unliked": "Новость удалена из избранного",
            "is_liked": "Статья добавлена в избранное",
            "liked_already": "Статья уже добавлена в избранное",
            "is_unliked": "Статья удалена из избранного",
            "is_draft": "Черновик",
            "is_draft_moderate": "На модерации",
            "is_draft_rejected": "Снят с публикации",
            "open_post": "Перейти",
            "edit": "Редактировать",
            "yesterday_at": "Вчера в",
            "today_at": "Сегодня в",
            "at": "в",
            "delayed": "Отложен на",
            "cancel": "Отменить публикацию"
        }
    }
</i18n>

<template>
    <figure
        class="block-user-article"
        :class="rootClasses">

        <header class="user-article__header">
            <picture class="user-article-avatar">
                <img v-lazy-load :data-src="userPhoto" :alt="userName" />
            </picture>

            <div class="user-article-info">
                <h5 class="user-article-info__user-title">
                    {{ userName }}
                </h5>
                <p class="user-article-info__draft" v-if="isDraftModerate">{{ $t('is_draft_moderate') }}</p>
                <p class="user-article-info__draft" v-else-if="isDraftRejected">{{ $t('is_draft_rejected') }}</p>
                <p class="user-article-info__draft" v-else-if="formatedPublishDate">{{ $t('delayed') }} {{ formatedPublishDate }}</p>
                <p class="user-article-info__draft" v-else-if="isDraft">{{ $t('is_draft') }}</p>
                <p class="user-article-info__date" v-else-if="showPostDate">{{ datePost }}</p>
            </div>
        </header>

        <html-link v-if="url"
            class="block-user-article__link block-user-article__link_main"
            :url="url" />

        <div class="block-user-article__picture-wrapper" v-if="url">
            <picture class="block-user-article__picture"
                :class="pictureWrapClasses">

                <img
                    v-if="picture"
                    v-lazy-load :data-src="picture"
                    :alt="name" />

                <div v-else class="block-user-article__picture_no-image">
                    <svg-icon
                        name="icon-photo-current"
                        class="block-user-article__picture_no-image-icon" />
                </div>
            </picture>
        </div>

        <picture
            v-else
            @click.prevent="editDraftPost"
            class="block-user-article__picture"
            :class="pictureWrapClasses">

            <img
                v-if="picture"
                v-lazy-load :data-src="picture"
                :alt="name" />

            <div v-else class="block-user-article__picture_no-image">
                <svg-icon
                    name="icon-photo-current"
                    class="block-user-article__picture_no-image-icon" />
            </div>
        </picture>

        <div
            class="block-user-article__content"
            v-if="isRegular && name && name.length">

            <div class="block-user-article__name">
                {{ unescapedName }}
            </div>
        </div>
        <div class="block-user-article__content-wrapper"
            v-if="description && description.length">

            <div v-if="isRegular"
                :class="descriptionClasses"
                class="block-user-article__description">
                {{ unescapedDesc }}
            </div>
        </div>

        <footer
            class="block-user-article__footer"
            v-if="!withoutFooter && isRegular">
            <div
                v-if="!isDraft"
                class="block-user-article__icon-text block-user-article__likes"
                @click="onLike">
                <svg-icon :name="heartIcon(liked)"/>
                <span> {{ likesCount || 0 }} </span>
            </div>
            <div v-if="!isDraft" class="block-user-article__icon-text block-user-article__comments">
                <html-link
                    class="block-user-article__link block-user-article__link_full"
                    v-if="url || getLinkTo(true)"
                    :url="getLinkTo(true) ? null : url + '#comments'"
                    :to="getLinkTo(true)"/>
                <svg-icon name="icon-message-current"/>
                <span> {{ comments || 0 }} </span>
            </div>
            <div v-if="!isDraft" class="block-article__buttons">
                <html-link v-if="url"
                    class="user-article__open"
                    :url="url">
                    {{ $t('open_post') }}</html-link>
            </div>

            <button v-else-if="formatedPublishDate"
                class="user-article__edit user-article__edit_cancel"
                @click.prevent="cancelAutoPublish">
                {{ $t('cancel') }}
            </button>

            <button v-else-if="isDraft"
                class="user-article__edit"
                @click.prevent="editDraftPost">
                {{ $t('edit') }}
            </button>
        </footer>

    </figure>
</template>

<script>
import dayjs from 'dayjs';
import { mapGetters } from 'vuex';
import get from 'lodash/get'
import includes from 'lodash/includes'
import uniqueId from 'lodash/uniqueId'
import unescape from 'lodash/unescape'

import OfferMixin from '@/mixins/catalog/offers.mixin'
import ButtonActionsMixin from '@/mixins/catalog/buttonActions'
import ModelMixin from '@/mixins/model.mixin'

export default {
    name: 'BlockUserArticle',
    mixins: [ ModelMixin, OfferMixin, ButtonActionsMixin ],
    props: {
        entityType: {
            type: String,
            default: null
        },
        section: {
            type: Object,
            default: () => {}
        },
        withoutFooter: {
            type: Boolean,
            default: false
        },
        size: {
            type: String,
            default: 'regular',
            validator(value) {
                return includes(['wide', 'regular'], value)
            }
        },
        source: {
            type: String,
            default: null
        },
        code: {
            type: String,
            default: null
        },
        userUrl: {
            type: String,
            default: null
        },
        url: {
            type: String,
            default: null
        },
        views: {
            type: [ String, Number ],
            default: ''
        },
        likes: {
            type: [ String, Number ],
            default: ''
        },
        comments: {
            type: [ String, Number ],
            default: ''
        },
        authorPhoto: {
            type: String,
            default: null
        },
        smallDescription: {
            type: Boolean,
            default: true
        },
        user: {
            type: Object,
            default: () => {}
        },
        isDraft: {
            type: Boolean,
            default: false
        },
        isDraftRejected: {
            type: Boolean,
            default: false
        },
        isDraftModerate: {
            type: Boolean,
            default: false
        },
        isDraftAutoPublish: {
            type: Boolean,
            default: false
        },
        draftId: {
            type: [String, Number],
            default: null
        },
        autoPublishDate: {
            type: String,
            default: null
        }
    },
    data() {
        return {
            liked: false,
            userRatings: null,
            id: null,
            isLikeProcess: false,
            formatedPublishDate: this.isDraftAutoPublish && this.autoPublishDate ? dayjs(this.autoPublishDate).format('DD.MM.YYYY, HH:mm') : null
        }
    },
    globalBus: {
        'fetch-complete'() {
            if(!this.code) return
            this.userRatings = this.getRatingsByCode(this.code, this.ratingsEntityType)
            this.liked = !!this.userRatings
        }
    },
    computed: {
        ...mapGetters(['getNoImage', 'getRatingsByCode', 'getUserNoImageLarge']),
        translations() {
            return {
                lastday_in: this.$t('date.lastday_in'),
                today_in: this.$t('date.today_in'),
                in: this.$t('date.in'),
            };
        },
        pictureWrapClasses() {
            return {
                'block-user-article__picture_empty': !this.picture
            }
        },
        showPostDate() {
            return !this.isDraft && this.datePost
        },
        datePost() {
            if (this.date) {
                return this.$options.filters.datePost(this.date, this.translations);
            }

            return null
        },
        userPhoto() {
            return get(this.user, 'photo.url', this.getUserNoImageLarge);
        },
        userName() {
            return get(this.user, 'fullName', '');
        },
        isRegular() {
            return this.size === 'regular'
        },
        isWide() {
            return this.size === 'wide'
        },
        descriptionClasses() {
            return {
                'block-user-article__description_small': this.smallDescription
            }
        },
        rootClasses() {
            return {
                'block-user-article_wide': this.size === 'wide'
            }
        },
        isEdition() {
            return this.source === 'edition'
        },
        likesCount() {
            let likes = this.likes

            if (this.userRatings && likes) likes--
            if (this.liked) likes++

            return likes
        },
        likeEventName() {
            return 'user-like-article-' + this.id
        },
        page() {
            if (this.entityType) {
                return this.entityType === 'news' ? 'news' : 'articles'
            }

            const isNews = includes(this.url, '/news/')

            return isNews ? 'news' : 'articles'
        },
        ratingsEntityType(){
            return this.entityType === 'news' ? 'news' : 'article'
        },
        unescapedName(){
            return unescape(this.name)
        },
        unescapedDesc(){
            return unescape(this.description)
        }
    },
    beforeDestroy(){
        this.$bus.$off(this.likeEventName)
    },
    mounted() {
        this.id = 'article_' + uniqueId()

        if (this.code) {
            this.userRatings = this.getRatingsByCode(this.code, this.ratingsEntityType)
            this.liked = !!this.userRatings
        }

        // eslint-disable-next-line
        if (process.client) {
            this.$bus.$on(this.likeEventName, async value => {
                if(!this.code) return

                const model = this.getInstanseByPage(this.page, this.code)
                if (!model) return

                let notices = {}

                if (this.page === 'news') {
                    notices = {
                        'onLiked': this.$t("news_is_liked"),
                        'onUnliked': this.$t("news_is_unliked"),
                        'onLikeAlready': this.$t("news_liked_already"),
                    };
                } else {
                    notices = {
                        'onLiked': this.$t("is_liked"),
                        'onUnliked': this.$t("is_unliked"),
                        'onLikeAlready': this.$t("liked_already"),
                    };
                }

                this.liked = await this.onActionLike(
                    value,
                    model,
                    notices
                )

                this.isLikeProcess = false;
            })
        }
    },
    methods: {
        get,
        ...mapGetters(['']),
        getLinkTo(toHash) {
            const isNews = includes(this.url, '/news/')

            const code = this.code
            const rubric = get(this.section, 'code')

            if (!code || !rubric) return

            const routeOptions = {
                name: isNews ? 'NewsDetail' : 'ArticlesDetail',
                params: {
                    code,
                    rubric
                },
            }

            if (toHash) routeOptions.hash = '#comments'

            return routeOptions
        },
        onLike() {
            if (!this.code) return
            if(!this.isLikeProcess){
                this.isLikeProcess = true;
                this.$authEmit(this.likeEventName, !this.liked)
            }
        },
        editDraftPost() {
            if(!this.formatedPublishDate)
                this.showPopup('content-editor', {
                    draftId: this.draftId,
                    type: this.entityType,
                    updateEvent: this.entityType + '-draft-updated'
                });
        },
        async cancelAutoPublish(){
            try{
                await this.$api.delete(`/users/accounts/${this.entityType}/drafts/${this.draftId}/published`).then(() => {
                    this.formatedPublishDate = null;
                });
            } catch (e) {
                this.$alert.error(e.response.data.message);
            }
        }
    }
};
</script>


<style lang="less">

.user-article {
    &__open,
    &__edit {
        background: none;
        border: none;
        color: @color-gray-light;

        padding: 0;

        .animate(opacity);

        .hover({
            color: @color-gray;
        });
    }

    &__edit {
        margin-left: auto;

        &_cancel{
            color: @color-red;
        }
    }

    &__open {
        margin-left: rem(16);

        .hover({
            color: @color-gray;
        });
    }

    &-avatar {
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 50%;
        height: rem(41);
        width: rem(41);
        overflow: hidden;
        backface-visibility: hidden;
        transform: translate3d(0, 0, 0);

        img {
            object-fit: cover;

            height: 100%;
            max-width: 100%;
            max-height: 100%;
            width: 100%;
        }

        &_preview {
            height: rem(24);
            width: rem(24);
        }
    }

    &__header {
        display: flex;
        flex-flow: row nowrap;
        align-items: flex-start;
    }

}


.user-article-info {
    margin-bottom: rem(15);
    padding-left: rem(12);

    width: calc(100% - rem(40));

    &__title {
        font-size: rem(15);
        font-weight: 400;
        line-height: 1.6;

        margin-bottom: rem(3);
        padding-top: rem(3);
    }

    &__user-title {
        font-size: rem(15);

        margin-top: rem(3);
        margin-bottom: rem(5);
    }

    &__draft,
    &__date {
        color: @color-gray;
        font-size: rem(13);

        margin: 0;
    }

    &__draft {
        color: @color-red;
    }

    &__link {
        color: @color-gray;

        .hover({
            color: @color-violet;
        })
    }

    &_preview {
        margin-bottom: 0;
        padding-left: rem(12);

        @{desktop} & {
            margin-bottom: 0;
            padding-left: rem(12);
        }
    }
}

.block-user-article {
    margin-bottom: 0;
    padding-top: rem(31);
    padding-bottom: rem(24);

    position: relative;

    overflow: hidden;

    .page-padding();

    &:last-child {
        @{mobile} & {
            border-bottom: none;
        }
    }

    @{desktop} & {
        display: flex;
        flex-direction: column;

        border-radius: rem(3);

        transition: box-shadow 0.2s ease;
    }

    &__link {
        display: block;

        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        z-index: 1;

        opacity: .5;

        transition: background-color .15s ease;

        &_full {
            bottom: 0;
        }

        &_main{
            top: rem(82);
            bottom: rem(58);

            &:hover{
                & ~ .block-user-article__content{

                    .block-user-article__name{
                        color: @color-violet;
                    }
                }
            }
        }
    }

    &__link-main:hover ~ &__content &__title {
        @media @hover {
            color: @color-primary;
        }
    }

    &__picture {
        display: block;

        background: @color-gray-light-2;
        border-radius: rem(3);

        height: rem(188);
        width: 100%;

        img {
            display: block;
            object-fit: cover;

            border-radius: rem(3);

            height: 100%;
            width: 100%;
        }

        @{desktop} & {
            height: rem(279);
        }

        &_no-image {
            display: flex;
            align-items: center;
            justify-content: center;
            cursor: default;

            height: 100%;

            &-icon {
                color: @color-gray-2;

                height: rem(35);
                width: rem(44);
            }
        }
    }

    &__content {
        display: flex;
        align-items: center;
        justify-content: space-between;

        font-size: rem(13);
        line-height: 1.2;

        padding-top: rem(17);
        padding-bottom: rem(0);

        &-wrapper {
            margin-top: rem(8);
        }
    }

    &__name {
        font-size: rem(20);
        font-weight: 500;
        line-height: 1.3;

        margin-right: rem(8);

        position: relative;

        transition: color .15s ease;

        .text-ellipsis(3);

        @{desktop} & {
            font-size: rem(20);
        }


        &-picture {
            border-radius: 50%;

            height: rem(20);
            width: rem(20);
        }
    }

    &__date {
        color: @color-gray-light;
        font-size: rem(12);

        padding-top: rem(2);

        @media @min375 {
            font-size: rem(13);
        }
    }

    &__title {
        font-size: rem(20);
        font-weight: 500;
        line-height: 130%;

        transition: color .15s ease;
    }


    &__description {
        font-size: rem(15);
        line-height: 150%;
        text-overflow: ellipsis;

        overflow: hidden;

        &_small {
            max-height: rem(46);

            @{desktop} & {
                max-height: rem(69);
            }
        }
    }

    &__icon-text {
        cursor: pointer;

        color: @color-gray-light;
        font-size: rem(13);
        font-weight: 500;
        text-overflow: ellipsis;
        white-space: nowrap;

        position: relative;
        z-index: 2;

        overflow: hidden;

        transition: color .15s ease;

        svg {
            height: rem(20);
            width: rem(20);
        }

        svg ~ span {
            display: inline-block;

            margin-left: rem(4);

            min-width: rem(14);
        }

        span ~ svg {
            margin-left: rem(2);
        }

        span {
            position: relative;
            top: rem(1);
        }
    }

    &__likes {
        margin-right: rem(22);
    }

    &__comments {
        margin-right: auto;
    }

    &__likes,
    &__comments {
        cursor: pointer;

        .hover({
            color: @color-gray;
        });
    }

    &__views {
        cursor: default;
    }

    &__footer {
        display: flex;
        justify-content: space-between;

        padding-top: rem(16);

        @{desktop} & {
            margin-top: auto;
        }
    }

    @{desktop} &_wide {
        padding-bottom: 0;
    }

    @{desktop} &_wide &__picture {
        height: 100%;
        max-height: rem(485);
    }

    @{desktop} &_wide &__title {
        color: @color-white !important;
        font-size: rem(24);
        margin-bottom: rem(8);
    }


    @{desktop} &_wide &__name {
        font-size: rem(15);
        font-weight: 500;

        .hover({
            color: @color-white;
        });
    }

    @{desktop} &_wide &__content {
        background: linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, black 100%);
        color: @color-white;

        padding-top: rem(48);
        padding-right: rem(32);
        padding-bottom: rem(32);
        padding-left: rem(32);

        position: absolute;
        right: 0;
        bottom: 0;
        left: 0;
    }

    @{desktop} &_wide:hover > &__link {
        @media @hover {
            background-color: @color-primary;
        }
    }
    @{desktop} &_wide:hover > &__content {
        z-index: 2;
    }
}
</style>

